(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chl-integrated-filters"] && !Shopify.designMode) return;
  try {
    function initIntegratedFilters() {
    const filtersRoot = document.getElementById('chl-integrated-filters');
    if (!filtersRoot) return;

    // Accordion functionality
    const accordionToggles = filtersRoot.querySelectorAll('.filter-accordion-toggle');

    accordionToggles.forEach((toggle) => {
      // Remove existing listener by cloning (avoids duplicate bindings when re-initializing)
      const newToggle = toggle.cloneNode(true);
      toggle.parentNode.replaceChild(newToggle, toggle);

      newToggle.addEventListener('click', function () {
        const targetId = this.getAttribute('data-target');
        const content = document.getElementById(targetId);
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          content.classList.add('collapsed');
        } else {
          this.setAttribute('aria-expanded', 'true');
          content.classList.remove('collapsed');
        }
      });
    });

    // Filter checkbox functionality with AJAX using Shopify filter URLs
    const filterCheckboxes = filtersRoot.querySelectorAll('.filter-checkbox');

    filterCheckboxes.forEach((checkbox) => {
      const newCheckbox = checkbox.cloneNode(true);
      checkbox.parentNode.replaceChild(newCheckbox, checkbox);

      newCheckbox.addEventListener('change', function () {
        const urlToAdd = this.getAttribute('data-filter-url-add');
        const urlToRemove = this.getAttribute('data-filter-url-remove');
        const tag = this.getAttribute('data-tag');
        const filterType = this.getAttribute('data-filter-type');

        if (this.checked && urlToAdd) {
          // Native Shopify facet filter with precomputed URL
          applyFilterUrlAjax(urlToAdd);
          return;
        } else if (!this.checked && urlToRemove) {
          // Native Shopify facet filter removal
          applyFilterUrlAjax(urlToRemove);
          return;
        }

        // Custom filters that don't have precomputed URLs (currently Product Form only)
        if (!tag || filterType === 'health') return;

        const url = new URL(window.location.href);

        // Decide which query parameter to use
        let paramKey = 'filter.p.tag';
        if (filterType === 'form') {
          // Product Form metafield facet
          paramKey = 'filter.p.m.shopify.food-supplement-form';
        }

        if (this.checked) {
          // Append value if not already present so filters stack
          const existingValues = url.searchParams.getAll(paramKey);
          if (!existingValues.includes(tag)) {
            url.searchParams.append(paramKey, tag);
          }
        } else {
          // Remove this specific value from the param list
          const existingValues = url.searchParams.getAll(paramKey);
          url.searchParams.delete(paramKey);
          existingValues
            .filter((t) => t !== tag)
            .forEach((t) => url.searchParams.append(paramKey, t));
        }

        // Update URL and fetch filtered products without full reload
        window.history.pushState({}, '', url.toString());
        fetchFilteredProducts(url.toString());
      });
    });

    // Reset all filters with AJAX
    const resetButton = document.getElementById('filter-reset-all-integrated');
    if (resetButton) {
      const newReset = resetButton.cloneNode(true);
      resetButton.parentNode.replaceChild(newReset, resetButton);

      newReset.addEventListener('click', function () {
        resetAllFiltersAjax();
      });
    }

    // Ingredient search with AJAX
    const ingredientSearch = document.getElementById('ingredient-search-integrated');
    if (ingredientSearch) {
      const newInput = ingredientSearch.cloneNode(true);
      ingredientSearch.parentNode.replaceChild(newInput, ingredientSearch);

      newInput.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          const searchTerm = this.value.trim();
          searchByIngredientAjax(searchTerm);
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initIntegratedFilters);
  
  // Apply a Shopify filter URL via AJAX
  function applyFilterUrlAjax(targetUrl) {
    const url = new URL(targetUrl, window.location.origin);
    
    // Update URL without full page reload
    window.history.pushState({}, '', url.toString());
    
    // Fetch filtered products for the new URL
    fetchFilteredProducts(url.toString());
  }
  
  function resetAllFiltersAjax() {
    const url = new URL(window.location.href);
    // Remove all Shopify filter and search params
    const paramsToDelete = [];
    url.searchParams.forEach((value, key) => {
      if (key.startsWith('filter.') || key === 'q') {
        paramsToDelete.push(key);
      }
    });
    paramsToDelete.forEach((key) => url.searchParams.delete(key));
    
    // Update URL without refresh
    window.history.pushState({}, '', url.toString());
    
    // Reset all checkboxes
    document.querySelectorAll('.filter-checkbox').forEach(checkbox => {
      checkbox.checked = false;
    });
    
    // Clear search input
    const searchInput = document.getElementById('ingredient-search-integrated');
    if (searchInput) {
      searchInput.value = '';
    }
    
    // Fetch unfiltered products
    fetchFilteredProducts(url.toString());
  }
  
  function searchByIngredientAjax(searchTerm) {
    const url = new URL(window.location.href);
    
    if (searchTerm) {
      url.searchParams.set('q', searchTerm);
    } else {
      url.searchParams.delete('q');
    }
    
    // Update URL without refresh
    window.history.pushState({}, '', url.toString());
    
    // Fetch filtered products
    fetchFilteredProducts(url.toString());
  }
  
  function fetchFilteredProducts(url) {
    // Show loading state
    showLoadingState();
    
    // Get the section ID for the product grid - look for the main content section
    const productGridSection = document.querySelector('main [id*="shopify-section"]');
    const sectionId = productGridSection ? productGridSection.id.replace('shopify-section-', '') : null;
    
    if (!sectionId) {
      console.error('Could not find section ID for product grid');
      hideLoadingState();
      return;
    }
    
    // Create fetch URL with section parameter for HTML content
    const fetchUrl = new URL(url);
    fetchUrl.searchParams.set('section_id', sectionId);
    
    fetch(fetchUrl.toString())
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(html => {
        // Update the entire product grid section
        updateProductGrid(html);
        hideLoadingState();
      })
      .catch(error => {
        console.error('Error fetching filtered products:', error);
        hideLoadingState();
        // Fallback to page refresh if AJAX fails
        window.location.href = url;
      });
  }
  
  function updateProductGrid(html) {
    // Create a temporary container to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // Find the main product grid container using a more reliable selector
    const newProductsContainer = tempDiv.querySelector('[class*="grid-cols-3"]');
    const currentProductsContainer = document.querySelector('[class*="grid-cols-3"]');
    
    if (newProductsContainer && currentProductsContainer) {
      const productElements = Array.from(
        newProductsContainer.querySelectorAll('a[data-product-metafields]')
      );
      const debugProducts = productElements.map((el) => {
        const title =
          el.getAttribute('data-product-title') ||
          (el.querySelector('h3') ? el.querySelector('h3').textContent.trim() : '');
        const metafieldsRaw = el.getAttribute('data-product-metafields');
        const productJsonRaw = el.getAttribute('data-product-json');
        let productObject = {};
        try {
          if (productJsonRaw) {
            productObject = JSON.parse(productJsonRaw);
          }
        } catch (e) {
          console.warn('Failed to parse product JSON for', title, e);
        }

        const productKeys = Object.keys(productObject || {});
        const metafieldKeys = productObject && productObject.metafields
          ? Object.keys(productObject.metafields)
          : [];

        return {
          title,
          productKeys,
          metafieldKeys,
          metafieldsRaw,
          productObject,
        };
      });
      console.log('Filtered products (full debug):', debugProducts);
      
      // Replace the products grid content
      currentProductsContainer.innerHTML = newProductsContainer.innerHTML;
    }
    
    // Also replace the filters sidebar so Shopify filter URLs stay in sync
    const newFilters = tempDiv.querySelector('#chl-integrated-filters');
    const currentFilters = document.querySelector('#chl-integrated-filters');
    if (newFilters && currentFilters) {
      currentFilters.innerHTML = newFilters.innerHTML;
      // Re-initialize filter interactions on the new DOM
      initIntegratedFilters();
    }
    
    // Update product count
    const productCountRegex = /Showing\s+\d+\s+products?/;
    const tempText = tempDiv.textContent || tempDiv.innerText || '';
    const countMatch = tempText.match(productCountRegex);
    
    if (countMatch) {
      const currentCountElement = document.querySelector('p');
      if (currentCountElement && currentCountElement.textContent.includes('Showing')) {
        currentCountElement.textContent = countMatch[0];
      }
    }
    
    // Update pagination if it exists
    const newPagination = tempDiv.querySelector('.pagination');
    const currentPagination = document.querySelector('.pagination');
    if (newPagination && currentPagination) {
      currentPagination.innerHTML = newPagination.innerHTML;
    } else if (!newPagination && currentPagination) {
      // Hide pagination if no products require it
      currentPagination.style.display = 'none';
    }
  }
  
  function showLoadingState() {
    const productsGrid = document.querySelector('[class*="grid-cols-3"]');
    if (productsGrid) {
      productsGrid.style.opacity = '0.5';
      productsGrid.style.pointerEvents = 'none';
    }
    
    // Add loading spinner if it doesn't exist
    if (!document.querySelector('.filter-loading')) {
      const loadingDiv = document.createElement('div');
      loadingDiv.className = 'filter-loading fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50';
      loadingDiv.innerHTML = '<div class="bg-white p-4 rounded-lg shadow-lg"><div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div></div>';
      document.body.appendChild(loadingDiv);
    }
  }
  
  function hideLoadingState() {
    const productsGrid = document.querySelector('[class*="grid-cols-3"]');
    if (productsGrid) {
      productsGrid.style.opacity = '1';
      productsGrid.style.pointerEvents = 'auto';
    }
    
    // Remove loading spinner
    const loadingDiv = document.querySelector('.filter-loading');
    if (loadingDiv) {
      loadingDiv.remove();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
